import { useEffect, useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahAtAGlance.css";
import "../hexagon.css";
import "../styles/HexGrid.css";
import "../App.css";
import "../styles/UtahVerticals.css";
const auto = "/img/auto.webp";

const leftPanel = [
   {
    label: "Utah Water Security Gauge",
    title: "Utah Water Security Gauge",
    text: "Track Utah's reservoir storage, renewable water supply, annual demand, structural gap, basin stress, and Great Salt Lake-linked water security outlook.",
    imagepath: "/img/landing-webp/utah-water.webp",
    url: "/utah-at-a-glance/utah-water-security-gauge",
   },
   {
    label:"High Voltage Transmission",
    title: "Utah High Voltage Transmission",
    text: "Explore Utah's high voltage transmission infrastructure, including key lines, substations, and grid interconnections that support the state's energy needs.",
    imagepath: "/img/landing-webp/hvt.webp",
    url: "/utah-at-a-glance/high-voltage-transmission",


   },
//    {
//     label: "Who Uses UtahData",
//     title: "Who Uses UtahData",
//     text: "See the kinds of Utah data available on the site and the audiences who can use it, from economists and educators to policymakers and tourists.",
//     imagepath: "/img/landing-webp/close-up-magnifying-glass-map.webp",
//     url: "/utah-at-a-glance/who-uses-utahdata",
//    },
   
//    {
//     label: "in-demand-jobs-and-wages",
//     title: "In-Demand Jobs and Wages",
//     text: "Explore Utah's in-demand jobs and wages, highlighting high-growth industries and competitive salaries across the state.",
//     imagepath: "/img/landing-webp/InDemandJobsWages.webp",
//     url: "/utah-at-a-glance/in-demand-jobs-and-wages",
//    },
//    {
//     label: "Utah legislature",
//     title: "Utah Legislature",
//     text: "Explore the Utah Legislature's structure, members, and legislative process, providing insights into how laws are made in the Beehive State.",
//     imagepath: "/img/landing-webp/Utah-legislature.webp",
//     url: "/utah-at-a-glance/utah-legislature",
//    },  
  
   { 
    label:"Utah land ownership distribution",   
    title: "Utah Land Ownership Distribution",
    text: "Explore the distribution of land ownership in Utah, including federal, state, private, and tribal lands, and understand how these categories shape the state's landscape and resource management.",
    imagepath: "/img/landing-webp/utahfaqbg.jpg",
    url: "/utah-at-a-glance/utah-land",

  }, 
    {
        label:"Utah-history",
        title: "Utah History",
        text: "Explore Utah's rich history, from indigenous cultures and pioneer settlements to modern developments, shaping the state's unique identity and heritage.",
        imagepath: "/img/landing-webp/UTDT-History.webp",
        url: "/utah-at-a-glance/utah-history",
    },
 {
        label: "Utah Schools",
        title: "Utah Schools",
        text: "Explore Utah's education landscape, from K-12 districts to higher education institutions, and understand how Utah is shaping the future of learning.",
        imagepath: "/img/landing-webp/utahschools.webp",
        url: "/utah-at-a-glance/universities-and-schools/utah-schools",
    },
  {
        label: "Utah Charter Schools",
        title: "Utah Charter Schools",
        text: "Utah's charter school system is a dynamic and growing part of the state's education landscape. These schools operate with greater autonomy than traditional public schools, allowing them to offer innovative programs and specialized learning environments to students across the state.",
        imagepath: "/img/landing-webp/utah-charter-school.webp",
        url: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
    },
    
    {
    label: "Construction Intelligence",
    title: "Construction Intelligence",
    text: "Explore comprehensive construction metrics, workforce trends, and major projects in Utah's booming construction sector.",
    imagepath: "/img/landing-webp/cons.webp",
    url: "/utah-at-a-glance/construction-intelligence",
    },
      {
        label: "KCG Sandbox",
        title: "KCG Sandbox",
        text: "Research-grade KPIs turned into a clean, drillable web experience — built directly from the 2026 Economic Report to the Governor.",
        imagepath: "/img/landing-webp/KEMC.webp",
        url: "/kcg-sandbox",
    },
     {
        label: "Hill Airforce Base Economic Impact",
        title: "Hill Airforce Base Economic Impact",
        text: "Hill Air Force Base in Utah is a major U.S. Air Force installation known for its critical role in aircraft maintenance...",
        imagepath: "/img/landing-webp/aerospace.webp",
        url: "/verticals/hill-airforce-base-economic-impact",
    },
    {
        label: "Utah Nonprofit Data Insights",
        title: "Utah Nonprofit Data Insights",
        text: "Explore Utah's nonprofit sector with data-driven insights on organizations, impact, and community engagement across the state.",
        imagepath: "/img/landing/service.webp",
        url: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
    },
    {
        label: "NonProfits",
        title: "Nonprofits",
        text: "Utah is home to numerous non-profit organizations dedicated to serving communities, protecting the environment, supporting vulnerable populations, and enhancing quality of life across the state.",
        imagepath: "/img/glance-webp/nonprofits.webp",
        url: "/utah-at-a-glance/utah-nonprofits",
    },
    {
        label: "Operation Gigawatt",
        title: "Utah Operation Gigawatt",
        text: "Explore Utah's Operation Gigawatt initiative focused on energy growth, infrastructure readiness, and long-term statewide capacity planning.",
        imagepath: "/img/glance-webp/powergrid.webp",
        url: "/utah-at-a-glance/utah-operation-gigawatt",
    },
    //   {
    //     label: "Budget",
    //     title: "Budget",
    //     text: "Explore Utah's budget overview: revenues, expenditures, and priorities across the state.",
    //     imagepath: "/img/glance-webp/utah-budget.webp",
    //     url: "/utah-at-a-glance/utah-budget",
    // },
];

const DESKTOP_ROWS = [3, 4, 3];
const MOBILE_ROWS = [2, 1];

const buildRows = (items, pattern) => {
    const rows = [];
    let startIndex = 0;
    let patternIndex = 0;

    while (startIndex < items.length) {
        const rowSize = pattern[patternIndex % pattern.length];
        rows.push(items.slice(startIndex, startIndex + rowSize));
        startIndex += rowSize;
        patternIndex += 1;
    }

    return rows;
};

const visibleItems = leftPanel;

const WhatsNew = () => {
    const [isMobileHexLayout, setIsMobileHexLayout] = useState(() => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < 900;
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 899px)");
        const handleLayoutChange = (event) => {
            setIsMobileHexLayout(event.matches);
        };

        setIsMobileHexLayout(mediaQuery.matches);
        mediaQuery.addEventListener("change", handleLayoutChange);

        return () => {
            mediaQuery.removeEventListener("change", handleLayoutChange);
        };
    }, []);

    const hexRows = isMobileHexLayout
        ? buildRows(visibleItems, MOBILE_ROWS)
        : buildRows(visibleItems, DESKTOP_ROWS);

    return (
        <div>
            <LandingSection
                data={{
                    imageName: "whats-new-banner.webp",
                    title: "What's New on UTahData",
                    overlay: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(161, 66, 66, 0.4))"
                }}
            />
            <div className="utah-at-a-glance-section">
                <div className="utah-at-a-glance-intro">
                    <div className="utah-at-a-glance-intro-sec1">
                        <h2>
                            New Frontiers. Fresh Insights. See Utah at a Glance.
                        </h2>
                    </div>
                    <div className="utah-at-a-glance-intro-sec2">
                        <p>
                            Stay updated with the latest trends and data points that help shape Utah. These featured pages represent the most recent additions and updates to our platform, giving you a quick overview of what's evolving in the Beehive State.
                        </p>
                    </div>
                </div>
            </div>

            <div className="whats-new-grid-container">
                {hexRows.map((rowItems, rowIndex) => (
                    <div
                        className={`hex-row ${!isMobileHexLayout && rowIndex === 1 ? "row-middle" : ""}`.trim()}
                        key={`hex-row-${rowIndex}`}
                    >
                        <ul id="hexGrid">
                            {rowItems.map((btn) => (
                                <li className="hex" key={btn.label}>
                                    <div className="hexIn">
                                        <a className="hexLink" href={btn.url || "#"}>
                                            <div className="hexBorder">
                                                <div
                                                    className="img"
                                                    style={{
                                                        backgroundImage: `url(${btn.imagepath})`,
                                                    }}
                                                >
                                                    <div className="imgOverlay"></div>
                                                </div>
                                            </div>
                                            <div className="demo2">{btn.label}</div>
                                        </a>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
<br/><br/>
            <Footer />
        </div>
    );
};

export default WhatsNew;
